module.exports = __webpack_public_path__ + "static/media/bird_guard.6eca45f7.webp";